// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__mokjz","btn":"styles_btn__17gxd"};